/**
 * Dòng "Người đặt" ở chi tiết đơn (hợp đồng v3 §14.4.4.4): đơn web / Mini App
 * lưu người nhận ở customer_name / customer_phone, người đặt ở orderer_*. Chỉ
 * hiện khi người đặt khác người nhận; null = không hiện.
 */
export function ordererLine(order: {
    customer_name: string
    customer_phone?: string | null
    orderer_name?: string | null
    orderer_phone?: string | null
}): string | null {
    const name = order.orderer_name?.trim() ?? ''
    const phone = order.orderer_phone?.trim() ?? ''
    if (!name && !phone) return null
    if (
        name === order.customer_name &&
        phone === (order.customer_phone ?? '')
    ) {
        return null
    }
    return [name, phone].filter(Boolean).join(' · ')
}
